import React from 'react'

export interface IConfirmationModal {
  title: string
  actions: React.ReactNode
}

const ConfirmationModal = ({ title, actions }: IConfirmationModal) => {
  return (
    <div className="fixed left-0 top-0 z-30 h-screen w-screen bg-dark-blue bg-opacity-60">
      <div className="absolute left-1/2 top-1/2 grid w-96 -translate-x-1/2 -translate-y-1/2 gap-8 rounded-xl border border-white border-opacity-20 bg-navy-blue p-8">
        <h2 className="whitespace-normal">{title}</h2>
        <div className="grid grid-flow-col gap-6">{actions}</div>
      </div>
    </div>
  )
}

export default ConfirmationModal
